// extracted by css-extract-rspack-plugin
export default {"statusIndicator":"TriageAgentButton-module__statusIndicator__RIEbZ","pulse":"TriageAgentButton-module__pulse__nsuJu"};